import { render, staticRenderFns } from "./EcommerceOrder.vue?vue&type=template&id=6d9e47fc"
import script from "./EcommerceOrder.vue?vue&type=script&lang=js"
export * from "./EcommerceOrder.vue?vue&type=script&lang=js"
import style0 from "./EcommerceOrder.vue?vue&type=style&index=0&id=6d9e47fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports